import React, { Component } from 'react';
import { projects } from 'data/projects.json';

import Carousel from 'components/carousel';
import Iphone from 'components/iphone';
import Macbook from 'components/macbook';
import OutboundLink from 'components/outbound-link';
import Wrapper from 'components/wrapper';
import { ProjectDescription, ProjectIntro, ProjectPage } from 'components/project';
import Badge from 'components/badge';
import SocialShare from 'components/social';

import Icon from '../../../components/icon';
import styles from './styles.module.css';

import coverImage from 'components/project/img/SwiPolitique.jpg';

/*const images = [
  {
    src: require('./img/collection-listing.jpg'),
    description: 'Life with Bird collection listing',
  }
]; */




const mobileImages = [
  {
    src: require('./img/anoscreen.png'),
    description: 'Life with Bird product mobile',
  },
  {
    src: require('./img/left.png'),
    description: 'Life with Bird product listing mobile',
  },
  {
    src: require('./img/rank.png'),
    description: 'Life with Bird cart mobile',
  }
];

export default class Swiperie extends Component {
  render() {
    const project = projects.find(_project => _project.slug === 'swipolitique');

    const image = (
      <img src={coverImage} alt="Cover" />
    );

    const iphone = (
      <Iphone invert>
        <Carousel images={mobileImages} />
      </Iphone>
    );

    var textStyle= {
      textAlign: "left",
      fontSize: 20
    }

    var speStyle={
      fontWeight: 'bold',
      fontSize: 22
    }


    return (
      <ProjectPage project={project}>
        <ProjectIntro project={project} media={image} />
          <ProjectDescription
            media={iphone}
            appleUrl={project.appleUrl}
            googleUrl={project.googleUrl}
            >
              <h2>Comment vous aider à choisir ?</h2>
              <wrapper className={styles.sectionImg}>
                <div className={styles.imgPrez}>
                  <img src={require('./img/swipright.png')} alt="Swip" />
                </div>
                <p style={textStyle}>Triez différentes cartes avec les <text style={speStyle}>programmes</text> politiques de vos candidats.</p>
              </wrapper>

              <wrapper className={styles.sectionImg}>
                <div className={styles.imgPrez}>
                  <img src={require('./img/ranking.png')} alt="Rank" />
                </div>
                <p style={textStyle}>Un <text style={speStyle}>classement</text> est généré selon vos choix avec des statistiques détaillées.</p>
              </wrapper>

              <wrapper className={styles.sectionImg}>
                <div className={styles.imgPrez}>
                  <img src={require('./img/anonyme.png')} alt="Rank" />
                </div>
                <p style={textStyle}>Les idées des candidats sont présentées <text style={speStyle}>anonymement</text> pour éviter d'être influencés. </p>
              </wrapper>
              <wrapper className={styles.sectionImg}>
                <div className={styles.imgPrez}>
                  <img src={require('./img/demo.png')} alt="Rank" />
                </div>
              <p style={textStyle}>Pour une meilleure démocratie, vos <text style={speStyle}>statistiques</text> ne seront pas vendues.
              </p>
              </wrapper>

           </ProjectDescription>
           <SocialShare
             urlToShare="http://layouceferie.fr/work/swipolitique/"
             title="Swip Politique"
             description="Vous voulez savoir pour qui voter ? L'app Swip Politique est là pour vous aider."
             />
      </ProjectPage>
    );
  }
}

/*
<h3>Après les présidentielle 2017 ?</h3>
<p>SwiPolitique deviendra SwipCity ! <br />
Vous pourrez swiper entre les différentes caractéristique des grandes villes, cela vous aidera peut-être à prendre votre prochaine destination de vacances.</p>

*/
/*
<h3>Mais est-ce que cela va m'interesser ?</h3>
<p>C'est simple si vous aimez faire des choix et que vous aimez le concret ? C'est que vous êtes surement un roi ou une reine. </p>
<p>Vous adoré l'ordre, l'organisation et analysé les details. Vous ne rateriez surement pas les prochaines votes aux éléctions </p>
<p>Si c'est le cas cette application est faite pour vous.</p>
*/

//          <OutboundLink to="http://inlight.com.au">Inlight</OutboundLink>

/*
<Macbook>
  <Carousel images={images} />
</Macbook>
*/



// WEBPACK FOOTER //
// ./work/swipolitique/index.jsx